export const apiFetch = async (url, options = {}) => {
  const response = await fetch(url, {
    ...options,
    credentials: 'include',
  });

  if (response.status === 401 || response.status === 403) {
    localStorage.clear();
    sessionStorage.clear();
    window.dispatchEvent(new CustomEvent('session-expired'));
    return new Response(
      JSON.stringify({ success: false, message: 'Session expired' }),
      { status: 401, headers: { 'Content-Type': 'application/json' } }
    );
  }

  return response;
};